import StoreLocationsController from './store-locations-controller'

export default StoreLocationsController
